import { render, staticRenderFns } from "./BaselineToggle.vue?vue&type=template&id=b56e2694&scoped=true&"
import script from "./BaselineToggle.vue?vue&type=script&lang=ts&"
export * from "./BaselineToggle.vue?vue&type=script&lang=ts&"
import style0 from "./BaselineToggle.vue?vue&type=style&index=0&id=b56e2694&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e2694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56e2694')) {
      api.createRecord('b56e2694', component.options)
    } else {
      api.reload('b56e2694', component.options)
    }
    module.hot.accept("./BaselineToggle.vue?vue&type=template&id=b56e2694&scoped=true&", function () {
      api.rerender('b56e2694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/BaselineToggle.vue"
export default component.exports